import {Nav as NavContainer} from './Container';
import {NavFooter} from './Footer';
import {NavHeader} from './Header';
import {NavIcon} from './Icon';
import {NavMenuItem} from './Item';
import {NavMenuGroup as NavGroup} from './MenuGroup';
import {NavMenu} from './Menu';
import {NewNavIcon} from './NewIcon';
import {NewNavMenuItem} from './NewItem';
import {NewNavMenuGroup} from './NewMenuGroup';

type NavType = typeof NavContainer & {
  Container: typeof NavContainer;
  Footer: typeof NavFooter;
  Header: typeof NavHeader;
  MenuItem: typeof NavMenuItem;
  NewMenuItem: typeof NewNavMenuItem;
  MenuGroup: typeof NavGroup;
  NewMenuGroup: typeof NewNavMenuGroup;
  Menu: typeof NavMenu;
  Icon: typeof NavIcon;
  NewIcon: typeof NewNavIcon;
};

const Nav = NavContainer as NavType;
Nav.Container = NavContainer;
Nav.Footer = NavFooter;
Nav.Header = NavHeader;
Nav.MenuItem = NavMenuItem;
Nav.NewMenuItem = NewNavMenuItem;
Nav.MenuGroup = NavGroup;
Nav.NewMenuGroup = NewNavMenuGroup;
Nav.Menu = NavMenu;
Nav.Icon = NavIcon;
Nav.NewIcon = NewNavIcon;

// We do names export as well as dot-notation since next.js RSC doesn't support dot-notation pattern.
export {
  Nav,
  NavContainer,
  NavFooter,
  NavGroup,
  NavHeader,
  NavMenu,
  NavMenuItem,
  NewNavMenuGroup,
  NewNavMenuItem,
  NewNavIcon,
};
export type {NavProps} from './Container';
